import { createSlice } from '@reduxjs/toolkit';

// ----------------------------------------------------------------------

const initialState = {
  isOpenHistory: false,
  isOpenMyDownline: false,
};

const slice = createSlice({
  name: 'profilePages',
  initialState,
  reducers: {
    setOpenHistory(state, action) {
      state.isOpenHistory = action?.payload?.open;
    },
    setOpenMyDownline(state, action) {
      state.isOpenMyDownline = action?.payload?.open;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { setOpenHistory, setOpenMyDownline } = slice.actions;
